import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import MasteringTheBrush from "./sections/MasteringTheBrush";
import InteriorExteriorMastery from "./sections/InteriorExteriorMastery";
import TheEliteStandard from "./sections/TheEliteStandard";
import WhatOurClientsSay from "./sections/WhatOurClientsSay";
import ReadyForAChange from "./sections/ReadyForAChange";
import SiteFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <MasteringTheBrush />
      <InteriorExteriorMastery />
      <TheEliteStandard />
      <WhatOurClientsSay />
      <ReadyForAChange />
      <SiteFooter />
    </div>;
}